/**
 * Created by xixue on 2018/9/30.
 */
const rootUrl = window.location.host
let root2 = process.env.CH_API_ROOT
let socketHost,hostUrl = ''
switch (rootUrl) {
    case 'cn-new.classba.cn':
    case 'cn-new.171xue.com':
        socketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'socket.classba.cn'
        root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.classba.cn'
        break
    case 'cn-new.test.classba.cn':
    case 'cn-new.test.171xue.com':
        socketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'test-socket.classba.cn'
        root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.test.classba.cn'
        break
    default:
        socketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'test-socket.classba.cn'
        root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.classba.cn'
        hostUrl = 'test.'
        break
}

export { socketHost,hostUrl,root2 }



// WEBPACK FOOTER //
// ./src/utils/hostsconfig.js